module.exports = __webpack_public_path__ + "static/media/checked.730a7dec.svg";